// UI strings for <Repeat> in the lessons (lessons/components/Repeat.tsx): famous lines learnt whole,
// heard through the one player and said after it (Damien Halme's "phrases first, breakdown later",
// content round idea h2-i-0009). Finnish first; en has the same shape.
import { defineArea } from '../area';

export const phraseRepeatFi = {
  /** The block's accessible name. */
  label: 'Kuuntele ja toista',
};

export const phraseRepeatEn: typeof phraseRepeatFi = {
  label: 'Listen and repeat',
};

// Messages.phraseRepeat (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('phraseRepeat', phraseRepeatFi, phraseRepeatEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof phraseRepeatFi> {}
}
